import { render, staticRenderFns } from "./userEvents.vue?vue&type=template&id=09cca3c6&scoped=true&"
import script from "./userEvents.vue?vue&type=script&lang=js&"
export * from "./userEvents.vue?vue&type=script&lang=js&"
import style0 from "./userEvents.vue?vue&type=style&index=0&id=09cca3c6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cca3c6",
  null
  
)

export default component.exports